import * as z from "zod";

/**
 * A short-lived Entri token. The secret it is minted from stays on the server,
 * so this is the only half that ever reaches a browser.
 */
export const startEntriSession = {
  name: "startEntriSession" as const,
  /** Scoped to one claimed domain, and to its open attempt if there is one. */
  input: z.object({
    domain: z.string(),
    /** Must match what the browser hands Entri, or the token is refused. */
    offerDelegation: z.boolean().optional(),
  }),
  output: z.object({
    applicationId: z.string(),
    token: z.string(),
    expiresAt: z.date(),
    /** Tagged with the attempt, so the webhook can trust what comes back. */
    userId: z.string(),
  }),
};
